export default __webpack_public_path__ + "static/media/One.d614a703.png";